import lpApp from '../lp_app';
import { ConditionRuntime } from '../../logic/condition_tree';

/*
 * Project: LegalPlace assistant
 * File: src/app/ops/document.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

class LpOpsDocument {
  // check the documents' wrapper.
  checkWrappers() {
    const wrappers = lpApp.references.docs_wrappers;
    const results = {};
    if (typeof (wrappers) !== 'object') return results;

    wrappers.forEach((idx, index) => {
      const id = idx.doc_name;

      let truth = true;
      if (typeof (idx.conditions) === 'object' && typeof (idx.conditions.compiledConditions) === 'object' && idx.conditions.compiledConditions.length > 0) {
        const { conditions } = idx;
        const cond = new ConditionRuntime(conditions.compiledConditions);
        cond.compileDirect();
        truth = cond.execute(true);
      }
      results[index] = {
        name: id,
        cond: truth,
      };
    });
    return results;
  }
}


export default LpOpsDocument;



// WEBPACK FOOTER //
// ./src/app/ops/document.js